import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import ExternalDataCreditInfoItemsView
    from '../../PartialViews/ExternalData/ExternalDataViews/ExternalDataCreditInfoItemsView'

export interface IExternalDataByBDayPageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore: ExternalDataStore
    notificationsStore: NotificationsStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')

@observer
class ExternalDataByBDayPage extends React.Component<IExternalDataByBDayPageProps> {

    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        if (this.props['match']!['params']['bDay']) {
            this.props.httpActionsService!
                .getExternalDataByBDay(this.props['match']!['params']['bDay'])
        } else {
            this.props.notificationsStore
                .addAlert(
                    new NotificationEntity(
                        'danger',
                        this.props.localizationStore!.t('no bDay in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, localizationStore } = this.props

        if (externalDataStore!.isError) {
            return (<div>{this.props.localizationStore!.t('No data text')}</div>)
        }

        return (
            <div className="external-data-page">
                {!!externalDataStore!.getData && externalDataStore!.getData!.creditInfoItems.length
                    ? <ExternalDataCreditInfoItemsView
                        creditInfoItems={externalDataStore!.getData!.creditInfoItems}
                        headerText={localizationStore!.t!('Get external data by bDay')}
                    />
                    : this.props.localizationStore!.t('No data text')}
            </div>
        )
    }
}

export default withRouter(ExternalDataByBDayPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataByBDayPage.tsx